import { nanoid } from 'nanoid';
import classNames from 'classnames';

import { RadioIcon, RadioFilledAltIcon, RadioFilledIcon } from '../../icons';

import styles from './_index.module.scss';

export interface RadioProps {
  isChecked?: boolean;
  isInverseColor?: boolean;
  label?: React.ReactNode;
  name?: string;
  onChange?: (value: any) => void;
  value: any;
}

const Radio = ({
  isChecked,
  isInverseColor = false,
  label,
  name,
  onChange = () => {},
  value,
}: RadioProps) => {
  const id = nanoid();

  const handleChange = () => {
    onChange(value);
  };

  const renderRadioIcon = () => {
    if (isInverseColor && isChecked) return <RadioFilledAltIcon />;
    if (isChecked) return <RadioFilledIcon />;
    return <RadioIcon />;
  };

  return (
    <div
      className={classNames(styles['radio'], { [styles['is-checked']]: isChecked })}
      data-checked={isChecked}
    >
      <input checked={isChecked} id={id} name={name} onChange={handleChange} type="radio" />
      <label htmlFor={id}>
        <div className={styles['radio-icon']}>{renderRadioIcon()}</div>
        {label}
      </label>
    </div>
  );
};

export default Radio;
